module.exports = __webpack_public_path__ + "img/payment-award__sku.5bb35b4.png";